import styled from 'styled-components'

export const HiddenInput = styled.input`
  display: none;
`

export const ErrorMessage = styled.div`
  color: ${props => props.theme.colors.bodyErrorText};
`
